import { useMemo } from "react";

import type { Organism } from "@/graphql.ts";
import { useGetOrganismsQuery } from "@/modules/workflow/graphql/coordinate-lists.gql.ts";
import { useCheckVirtualGenomeExistsQuery } from "@/modules/workflow/graphql/virtual-genomes.gql.ts";

export const useCheckVirtualGenomeExists = (componentGenomes: number[]) => {
  const { data, loading, error } = useCheckVirtualGenomeExistsQuery({
    variables: { genomeIds: componentGenomes },
    skip: !componentGenomes.length,
  });

  const existingVirtualGenomes: Organism[] = useMemo(
    () => (data?.getVirtualGenomesForComponents ?? []) as Organism[],
    [data?.getVirtualGenomesForComponents],
  );

  return { loading, error: error?.message, existingVirtualGenomes };
};

export const useCheckSelectionContainsNoVirtualGenomes = (selectedGenomes: number[]) => {
  const { data, loading, error } = useGetOrganismsQuery({
    variables: { orgIds: selectedGenomes },
    skip: selectedGenomes.length === 0,
  });

  const selectionContainsVirtualGenome = useMemo(() => data?.organisms?.some((o) => o.isVirtual), [data?.organisms]);

  return { loading, error: error?.message, selectionContainsVirtualGenome, organisms: data?.organisms ?? [] };
};
